import { capture } from "./capture";

export const DbtModelsTracking = {
  /** dbt model detail page viewed. */
  detailViewed: (modelName: string, resourceType: string) => {
    capture("dbt_models.detail_viewed", { model_name: modelName, resource_type: resourceType });
  },

  /** Schema tab viewed on dbt model detail page. */
  schemaViewed: (modelName: string) => {
    capture("dbt_models.schema_viewed", { model_name: modelName });
  },

  /** Lineage tab viewed on dbt model detail page. */
  lineageViewed: (modelName: string) => {
    capture("dbt_models.lineage_viewed", { model_name: modelName });
  },

  /** Code tab viewed on dbt model detail page. */
  codeViewed: (modelName: string) => {
    capture("dbt_models.code_viewed", { model_name: modelName });
  },

  /** SQL Visualizer tab viewed on dbt model detail page. */
  sqlVisualizerViewed: (modelName: string) => {
    capture("dbt_models.sql_visualizer_viewed", { model_name: modelName });
  },

  /** Runs tab viewed on dbt model detail page. */
  runsViewed: (modelName: string) => {
    capture("dbt_models.runs_viewed", { model_name: modelName });
  },

  /** Opportunity selected on dbt model detail page. */
  opportunitySelected: (modelName: string, opportunityId: string) => {
    capture("dbt_models.opportunity_selected", {
      model_name: modelName,
      opportunity_id: opportunityId,
    });
  },
};
